const empty = () =>
    import( /* webpackChunkName: "empty" */ '../views/Empty.vue');

export default [{
    path: 'operation',
    name: 'Operation',
    component: empty,
    children: [{
            path: 'news',
            name: 'News',
            component: empty,
            children: [{
                    path: 'news-manage',
                    name: 'NewsManage',
                    component: () =>
                        import(
                            /* webpackChunkName: "operation" */
                            '../views/operation/news/NewsManage.vue'
                        ),
                    meta: {
                        title: "资讯管理",
                        root: true
                    }
                },
                {
                    path: 'news-edit',
                    name: 'NewsEdit',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/news/NewsEdit.vue'),
                    meta: {
                        title: "新建/编辑资讯"
                    }
                },
                {
                    path: 'catagory',
                    name: 'NewsCatagory',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/news/NewsCatagory.vue'),
                    meta: {
                        title: "资讯分类"
                    }
                },
            ]
        },
        {
            path: 'comment',
            name: 'Comment',
            component: empty,
            children: [{
                    path: 'course',
                    name: 'CommentCourse',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/comment/CommentCourse.vue'),
                    meta: {
                        title: "课程评论",
                        root: true
                    }
                },
                {
                    path: 'teacher',
                    name: 'CommentTeacher',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/comment/CommentTeacher.vue'),
                    meta: {
                        title: "讲师评论",
                        root: true
                    }
                },
                {
                    path: 'book',
                    name: 'CommentBook',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/comment/CommentBook.vue'),
                    meta: {
                        title: "图书评论",
                        root: true
                    }
                },
                {
                    path: 'exercise',
                    name: 'CommentExercise',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/comment/CommentExam.vue'),
                    meta: {
                        title: "章节练习",
                        root: true
                    }
                },
                {
                    path: 'exam',
                    name: 'CommentExam',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/comment/CommentExercise.vue'),
                    meta: {
                        title: "模考评论",
                        root: true
                    }
                }
            ]
        },
        {
            path: 'message',
            name: 'Message',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/message/Message.vue'),
            meta: {
                title: "消息管理",
                root: true
            }
        },
        {
            path: 'message-edit',
            name: 'MessageEdit',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/message/MessageEdit.vue'),
            meta: {
                title: "新建/编辑消息"
            }
        },
        {
            path: 'banner',
            name: 'Banner',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/banner/Banner.vue'),
            meta: {
                title: "banner配置",
                root: true
            }
        },
        {
            path: 'banner-edit',
            name: 'BannerEdit',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/banner/BannerEdit'),
            meta: {
                title: '新建/编辑'
            }
        },
        {
            path: 'mobile',
            name: 'Mobile',
            component: empty,
            children: [{
                    path: 'mobile-category',
                    name: 'MobileCategory',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/MobileCategory'),
                    meta: {
                        title: "首页配置",
                        root: true
                    }
                },{
                    path: 'mobile-recomment',
                    name: 'MobileRecomment',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/MobileRecomment'),
                    meta: {
                        title: "编辑首页配置",
                        root: true
                    }
                },
                {
                    path: 'mobile-feedback',
                    name: 'MobileFeedback',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/mobilefeedback/MobileFeedback.vue'),
                    meta: {
                        title: "意见反馈",
                        root: true
                    }
                },
                {
                    path: 'mobile-share',
                    name: 'MobileShare',
                    component: () =>
                        import( /* webpackChunkName: "operation" */ '../views/operation/mobileShare/MobileShare'),
                    meta: {
                        title: "分享模板",
                        root: true
                    }
                },
            ]
        },
        {
            path: 'set-course',
            name: 'SetCourse',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetCourse.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-teacher',
            name: 'SetTeacher',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetTeacher.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-vip',
            name: 'SetVip',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetVip.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-reservation',
            name: 'SetReservation',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetReservation.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-news',
            name: 'SetNews',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetNews.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-book',
            name: 'SetBook',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetBook.vue'),
            meta: {
                title: "编辑推荐"
            }
        },
        {
            path: 'set-exercise',
            name: 'SetExercise',
            component: () =>
                import( /* webpackChunkName: "operation" */ '../views/operation/mobileRecomment/SetExercise.vue'),
            meta: {
                title: "编辑推荐"
            }
        }
    ],
}, ];
